import React, { useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { MapPin, Phone, Mail, Send, Building, Users, Globe } from 'lucide-react';
export const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });
  const [formStatus, setFormStatus] = useState({
    submitted: false,
    error: false
  });
  const handleChange = e => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = e => {
    e.preventDefault();
    // In a real application, you would send the form data to a server
    // For this example, we'll just simulate a successful submission
    setFormStatus({
      submitted: true,
      error: false
    });
  };
  return <div className="min-h-screen flex flex-col" data-id="element-341">
      <Header data-id="element-342" />
      <main className="flex-grow pt-20" data-id="element-343">
        {/* Hero Banner */}
        <div className="bg-[#0a2351] text-white py-16" data-id="element-344">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-345">
            <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-346">Contact Us</h1>
            <p className="text-xl text-gray-200 max-w-2xl" data-id="element-347">
              We're here to answer your questions and discuss potential
              investment opportunities.
            </p>
          </div>
        </div>
        {/* Contact Content */}
        <section className="py-16 bg-white" data-id="element-348">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
            <div className="flex flex-col lg:flex-row gap-12" data-id="element-350">
              {/* Contact Form */}
              <div className="lg:w-7/12" data-id="element-351">
                <div className="bg-white rounded-lg shadow-md p-8" data-id="element-352">
                  <h2 className="text-2xl font-bold mb-6 text-[#0a2351]" data-id="element-353">
                    Get In Touch
                  </h2>
                  {formStatus.submitted ? <div className="text-center py-12" data-id="element-354">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 text-green-500 mb-6" data-id="element-355">
                        <Send size={24} data-id="element-356" />
                      </div>
                      <h3 className="text-2xl font-semibold mb-2 text-[#0a2351]" data-id="element-357">
                        Message Sent!
                      </h3>
                      <p className="text-gray-600" data-id="element-358">
                        Thank you for reaching out. Our team will get back to
                        you shortly.
                      </p>
                    </div> : <form onSubmit={handleSubmit} data-id="element-359">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-360">
                        <div className="mb-2" data-id="element-361">
                          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-362">
                            Full Name
                          </label>
                          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-363" />
                        </div>
                        <div className="mb-2" data-id="element-364">
                          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-365">
                            Email Address
                          </label>
                          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-366" />
                        </div>
                      </div>
                      <div className="mb-6" data-id="element-367">
                        <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-368">
                          Company
                        </label>
                        <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-369" />
                      </div>
                      <div className="mb-6" data-id="element-370">
                        <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-371">
                          Message
                        </label>
                        <textarea id="message" name="message" value={formData.message} onChange={handleChange} rows={5} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0a2351]" required data-id="element-372"></textarea>
                      </div>
                      <button type="submit" className="w-full py-3 px-4 bg-[#0a2351] text-white font-medium rounded-md hover:bg-[#0a2351]/90 transition-colors duration-300" data-id="element-373">
                        Submit
                      </button>
                    </form>}
                </div>
              </div>
              {/* Contact Information */}
              <div className="lg:w-5/12" data-id="element-374">
                <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-375">
                  <h3 className="text-xl font-semibold mb-6 text-[#0a2351]" data-id="element-376">
                    Contact Information
                  </h3>
                  <div className="space-y-6" data-id="element-377">
                    <div className="flex items-start" data-id="element-378">
                      <MapPin className="text-[#38b2ac] mr-4 mt-1" size={20} data-id="element-379" />
                      <div data-id="element-380">
                        <p className="font-medium" data-id="element-381">Main Office</p>
                        <p className="text-gray-600" data-id="element-382">
                          123 Finance Street, Suite 500
                          <br data-id="element-383" />
                          New York, NY 10001
                        </p>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-384">
                      <Phone className="text-[#38b2ac] mr-4" size={20} data-id="element-385" />
                      <div data-id="element-386">
                        <p className="font-medium" data-id="element-387">Phone</p>
                        <p className="text-gray-600" data-id="element-388">(212) 555-0123</p>
                      </div>
                    </div>
                    <div className="flex items-center" data-id="element-389">
                      <Mail className="text-[#38b2ac] mr-4" size={20} data-id="element-390" />
                      <div data-id="element-391">
                        <p className="font-medium" data-id="element-392">Email</p>
                        <p className="text-gray-600" data-id="element-393">info@sapiscapital.com</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-lg shadow-md p-8" data-id="element-394">
                  <h3 className="text-xl font-semibold mb-6 text-[#0a2351]" data-id="element-395">
                    How We Can Help
                  </h3>
                  <div className="space-y-4" data-id="element-396">
                    <div className="flex items-start" data-id="element-397">
                      <Building className="text-[#38b2ac] mr-4 mt-1" size={20} data-id="element-398" />
                      <div data-id="element-399">
                        <p className="font-medium" data-id="element-400">Investment Opportunities</p>
                        <p className="text-gray-600" data-id="element-401">
                          For businesses seeking growth capital
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-402">
                      <Users className="text-[#38b2ac] mr-4 mt-1" size={20} data-id="element-403" />
                      <div data-id="element-404">
                        <p className="font-medium" data-id="element-405">Investor Relations</p>
                        <p className="text-gray-600" data-id="element-406">
                          For existing or potential investors
                        </p>
                      </div>
                    </div>
                    <div className="flex items-start" data-id="element-407">
                      <Globe className="text-[#38b2ac] mr-4 mt-1" size={20} data-id="element-408" />
                      <div data-id="element-409">
                        <p className="font-medium" data-id="element-410">Media Inquiries</p>
                        <p className="text-gray-600" data-id="element-411">
                          For press and media contacts
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer data-id="element-412" />
    </div>;
};